import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-file-text',
    templateUrl: './icon-file-text.component.html',
    styleUrls: ['./icon-file-text.component.scss']
})
export class IconFileTextComponent implements OnInit {
    @Input() cssClass: string;

    constructor() { }

    ngOnInit(): void {
    }

}
